"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

/**
 * PageScrollManager ensures that the window scrolls to the top
 * whenever the user navigates to a different page (pathname change).
 * 
 * We use behavior: "instant" (or "auto") to override any global 
 * "scroll-behavior: smooth" CSS, ensuring the scroll reset happens
 * immediately before the new page content loads into view.
 */
export default function PageScrollManager() {
  const pathname = usePathname();

  useEffect(() => {
    // Scroll to top immediately when the pathname changes.
    // "instant" ensures we don't wait for a smooth scroll animation.
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" as any, // Cast to any as some TS versions might not have "instant" yet
    });
  }, [pathname]);

  useEffect(() => {
    const handleWheel = () => {
      const activeEl = document.activeElement;
      if (
        activeEl &&
        activeEl instanceof HTMLInputElement &&
        activeEl.type === "number"
      ) {
        activeEl.blur();
      }
    };

    window.addEventListener("wheel", handleWheel, { passive: true });
    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return null;
}
